/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aserviceby2Inputs */



/**
* | output |
* | --- |
* | "A service by" |
*
* @param {Aserviceby2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aserviceby2 = /** @type {((inputs?: Aserviceby2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aserviceby2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("A service by")
	return /** @type {LocalizedString} */ ("Ein Service von")
});
export { aserviceby2 as "aServiceBy" }